/**
 * Encode a `{business_location_uuid}#{client_phone_e164}` conversation key as the
 * opaque, URL-safe token the messaging API uses for `:conversationId`.
 *
 * Mirrors the backend `messaging_ids.encode_conversation_id`
 * (base64url, padding stripped). The API already returns ready-made
 * `conversation_id`s, so the ONLY place the frontend needs to encode is
 * matching a real-time Pusher event (which carries the raw `conversation_key`)
 * against the tokens in state.
 */
export function encodeConversationId(conversationKey: string): string {
  // conversation_key is ASCII (hex uuid + '#' + '+' + digits); the
  // encodeURIComponent/unescape dance keeps it correct for any UTF-8 anyway.
  const b64 = btoa(unescape(encodeURIComponent(conversationKey)));
  return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
